import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "../../../../vendor/legacy_rails_assets/jquery-timeago/jquery.timeago.js";

// Connects to data-controller="shared--timeago"
// Initializes jquery-timeago on the host element so views can opt in without
// the plugin being loaded globally.
export default class extends Controller {
  connect() {
    $(this.element).timeago();
  }

  disconnect() {
    $(this.element).timeago("dispose");
  }
}
